import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import { formatViews, getDetailPath } from '@/utils/content';

interface HotSidebarProps {
  title: string;
  items: ContentItem[];
}

export default function HotSidebar({ title, items }: HotSidebarProps) {
  return (
    <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex items-center gap-2 border-b border-background-200 pb-3">
        <i className="ri-fire-line text-accent-500"></i>
        <h3 className="font-heading text-base font-bold text-foreground-950">{title}</h3>
      </div>
      <ul className="space-y-1">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={getDetailPath(item)}
              className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-primary-50"
            >
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-secondary-600'
                }`}
              >
                {i + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 block text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-[11px] text-secondary-400">
                  <i className="ri-eye-line"></i>
                  {formatViews(item.views)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}